import React, { useState } from "react";
import "./Navbar.scss"
import logo from "../../assets/images/logo.png"
import menu from "../../assets/icons/menu.svg"
import close from "../../assets/icons/close.svg"

import { useHistory } from "react-router";
const Navbar = () => {
    const history = useHistory()
    const [showDropdown, setShowDropdown] = useState(false)

    const pages = [
        {
            "title": "Home",
            "href": "/"
        },
        {
            "title": "About",
            "href": "/about"
        }, {
            "title": "Menu",
            "href": "/menu"
        }, {
            "title": "Gallery",
            "href": "/gallery"
        },
        {
            "title": "Contact",
            "href": "/contact"
        },
    ]
    return (
        <div className="DosaChutneyNavbar">
            <div className="DosaChutneyNavbar-inner">
                <img className="DosaChutneyNavbar-logo" alt="" src={logo} />
                <div className="DosaChutneyNavbar-innerRight">
                    <div className="DosaChutneyNavbar-links">
                        {pages.map((page, key) => {
                            return (
                                <div
                                    className={`Navbarlink-title  ${window.location.pathname === page?.href ? "selected" : ""}`}
                                    key={key}
                                    onClick={() => {
                                        if (page?.href?.includes("https://")) {
                                            if (page?.href && page?.href !== "") {
                                                window.open(page?.href, '_blank')
                                            }
                                        } else {
                                            history.push(page?.href)
                                        }
                                    }}>
                                    {page?.title}
                                </div>
                            )
                        })}
                    </div>
                    <div className="DosaChutneyNavbar-button"
                        onClick={() => {
                            // if (buttonComponent?.href && buttonComponent?.href !== "") {
                            //     window.open(buttonComponent?.href, '_blank')
                            // }
                            // else {
                            // }
                        }
                        }>
                        BOOK NOW
                    </div>
                </div>
                {showDropdown ? <img className="DosaChutneyNavbar-icon" alt=""
                    onClick={() => {
                        setShowDropdown(!showDropdown)
                    }} src={close} /> :
                    <img className="DosaChutneyNavbar-icon" alt="" src={menu}
                        onClick={() => {
                            setShowDropdown(!showDropdown)
                        }} />}

            </div>
            {showDropdown && <div className={`DosaChutneyNavbar-Dropdown open`}>
                <div className="DosaChutneyNavbar-links">
                    {pages.map((page, key) => {
                        return (
                            <div
                                className={`Navbarlink-title  ${window.location.pathname === page?.href ? "selected" : ""}`}
                                key={key}
                                onClick={() => {
                                    if (page?.href?.includes("https://")) {
                                        if (page?.href && page?.href !== "") {
                                            window.open(page?.href, '_blank')
                                        }
                                    } else {
                                        history.push(page?.href)
                                    }
                                    setShowDropdown(false)
                                }}>
                                {page?.title}
                            </div>
                        )
                    })}
                </div>
                <div className="DosaChutneyNavbar-button"
                    onClick={() => {
                        // if (buttonComponent?.href && buttonComponent?.href !== "") {
                        //     window.open(buttonComponent?.href, '_blank')
                        // }
                        // else {
                        // }
                    }}>
                    BOOK NOW
                </div>
            </div>}

        </div>
    )
}
export default Navbar